import { render, staticRenderFns } from "./showVideo.vue?vue&type=template&id=c2646236&scoped=true&"
import script from "./showVideo.vue?vue&type=script&lang=js&"
export * from "./showVideo.vue?vue&type=script&lang=js&"
import style0 from "./showVideo.vue?vue&type=style&index=0&id=c2646236&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2646236",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('c2646236', component.options)
    } else {
      api.reload('c2646236', component.options)
    }
    module.hot.accept("./showVideo.vue?vue&type=template&id=c2646236&scoped=true&", function () {
      api.rerender('c2646236', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Camaras/showVideo.vue"
export default component.exports